export enum ReadOnlyOutputEnum {
  Warning,
  OK
}
